// Redux integrated routes
import Dashboard from "../Dashboard";
import Integrations from "../Integrations/Integrations";
import Settings from "../Settings";
import Table from "../Table";

const routes = [
  {
    path: "dashboard",
    name: "Dashboard",
    component: Dashboard,
    layout: "/user",
  },
  {
    path: "data-table",
    name: "Data Table",
    component: Table,
    layout: "/user",
  },
  {
    path: "settings",
    name: "Settings",
    component: Settings,
    layout: "/user",
  },
  {
    path: "change-password",
    name: "Settings",
    component: Settings,
    layout: "/user",
  },
  {
    path: "billing",
    name: "Settings",
    component: Settings,
    layout: "/user",
  },
  {
    path: "integration",
    name: "Integration",
    component: Integrations,
    layout: "/user",
  },
  {
    path: "subscription",
    name: "Settings",
    component: Settings,
    layout: "/user",
  },
];

export default routes;
